import React, { forwardRef, Ref } from 'react';
import { SignatureField as SignatureFieldData } from '@dropbox/sign-internal-client';
import { Timestamped } from './timestamped';
import { ImperativeAPI } from '../types/imperative-api';
import { SignatureImage } from './signature-image';

type Props = {
  fieldData: SignatureFieldData;
  showTimestamp?: boolean;
  isFormView?: boolean;
  onKeyPress?: (event: React.KeyboardEvent) => void;
  onTouchEnd?: (event: React.TouchEvent) => void;
  onClick?: (event: React.MouseEvent) => void;
  tabIndex?: number;
  'data-qa-ref'?: string;
  'data-testid'?: string;
};

function SignatureFieldInternal(
  {
    fieldData,
    showTimestamp,
    isFormView,
    onKeyPress,
    onTouchEnd,
    onClick,
    tabIndex,
    'data-qa-ref': dataQaRef,
    'data-testid': dataTestId,
  }: Props,
  ref: Ref<ImperativeAPI>,
) {
  if (fieldData.signature != null) {
    const img = (
      <SignatureImage
        isFormView={isFormView}
        signer={fieldData.signer}
        signatureGuid={fieldData.signature.guid}
        onKeyPress={onKeyPress}
        onTouchEnd={onTouchEnd}
        onClick={onClick}
        tabIndex={tabIndex}
        data-qa-ref={dataQaRef}
        data-testid={dataTestId}
        ref={ref}
      />
    );

    if (showTimestamp && fieldData.signerName) {
      return (
        <Timestamped fieldHeight={fieldData.height} name={fieldData.signerName}>
          {img}
        </Timestamped>
      );
    }

    return img;
  }

  return null;
}

export const SignatureField = forwardRef(SignatureFieldInternal);
